import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { createChildAccount } from '../../../api'; // Adjust the path as necessary
import MyButton from '../../basic/MyButton'; // Adjust path if necessary
import MyTextInput from '../../basic/MyTextInput'; // Adjust path if necessary

Modal.setAppElement('#root'); // Ensure this is set for accessibility

function ModalCreateNewAccount({ isOpen, onClose, childId, notifySuccess }) {
    const [accountName, setAccountName] = useState('');
    const [goalAmount, setGoalAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            setAccountName('');
            setGoalAmount('');
            setError('');
        }
    }, [isOpen]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'accountName') {
            setAccountName(value);
        } else if (name === 'goalAmount') {
            setGoalAmount(value);
        }
    };

    const handleCreateAccount = async (e) => {
        e.preventDefault();
        if (!accountName.trim()) {
            setError('Account name is required.');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const accountData = {
                account_name: accountName.trim(),
                goalAmount: goalAmount ? parseFloat(goalAmount) : null
            };

            await createChildAccount(childId, accountData);
            notifySuccess('New account created successfully!');
            onClose();
        } catch (err) {
            console.error('Error creating account:', err);
            setError('Failed to create account. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={{
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)'
                }
            }}
        >
            <h2>Create New Savings Account</h2>
            <p>Turn saving into a game! Set goals for accounts and keep score as savings grow.</p>
            {error && <div style={{ color: 'red' }}>{error}</div>}
            <form onSubmit={handleCreateAccount}>
                <MyTextInput
                    label="Account Name"
                    name="accountName"
                    value={accountName}
                    onChange={handleInputChange}
                    required
                />
                <MyTextInput
                    label="Saving Goal Amount - Optional"
                    name="goalAmount"
                    value={goalAmount}
                    onChange={handleInputChange}
                    type="number"
                    min="0"
                    step="0.01"
                />
                <MyButton 
                    text={loading ? 'Creating...' : 'Create Account'} 
                    onClick={handleCreateAccount} 
                    disabled={loading}
                />
                <MyButton 
                    text="Cancel" 
                    onClick={onClose} 
                    backgroundColor="white"
                    color="#dc3545"
                    hoverBackgroundColor="#f8f8f8"
                    hoverColor="#c82333"
                />
            </form>
        </Modal>
    );
}

export default ModalCreateNewAccount;